import React, { useContext, useEffect } from 'react'
import { Link, redirect, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components'
import { MyContext } from '../context/Context';
import { logout } from '../api/api';
import { toast } from 'react-toastify';
import api from '../api/url';
import { Height, WidthFull } from '@mui/icons-material';

function Navbar() {
    const { adminData, setAdminData, userType } = useContext(MyContext);
    const redirect = useNavigate(null);

    const location = useLocation();
    const currentPath = location.pathname;

    // console.log(adminData)
    // if (currentPath == "/dashboard") {

    //     document.body.classList.add("sidebar-closed");
    //     document.body.classList.remove("sidebar-open");

    // }



    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    useEffect(() => {
        if (!localStorage.getItem("admin_data")) {
            redirect("/");
        }
    }, []);


    //--------------logout api call--------------//
    const logout_Api_call = async () => {
        try {
            const res = await logout();

            if (res.status === 200) {
                redirect('/');
                localStorage.removeItem('token');
                localStorage.removeItem('admin_data');
                setAdminData([]);
                toast.success("Logout successful");
            } else {
                console.error("logout Failed")
            }
        } catch (error) {
            console.error("logout api error", error);
        }
    };


    return (

        <Nav className={`${userType !== 'delivery_boy' ? 'main-header' : ''} navbar navbar-expand navbar-white navbar-light sticky-top`}>
            {/* {/ Left navbar links /} */}
            {
                userType !== 'delivery_boy'
                    ? (
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a className="nav-link three-line" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars naariyal-text-white" /></a>
                            </li>
                        </ul>
                    )
                    : ''
            }

            {/* {/ Right navbar links /} */}
            <ul className="navbar-nav ml-auto position-relative">

                {/* {/ Sidebar user panel (optional) /} */}
                <li className="nav-item dropdown">
                    <a className="user-panel mt-2 mb-2 d-flex" data-toggle="dropdown" href="#">

                        <div className="navbar-user-profile border border-secondary">
                            {
                                adminData.user_profile ?
                                    <img src={`${api.imageUrl}${adminData.user_profile}`} className="img-circle elevation-2" alt="User Image" />
                                    : <img src='https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG-Clipart.png' className="img-circle elevation-2" alt="User Image" />
                            }
                        </div>
                        <div className="info">
                            <span className="d-block text-capitalize naariyal-text-white">{adminData.firstname + " " + adminData.lastname}</span>
                        </div>
                    </a>
                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right ">

                        {
                            userType !== 'delivery_boy' ? (
                                <>
                                    <div className="dropdown-divider" />
                                    <Link
                                        to="/profile" className="dropdown-item"
                                    >
                                        <i className="fa-solid fa-user mr-4"></i> Profile
                                    </Link>
                                    <div className="dropdown-divider" />
                                </>
                            )
                                : ''

                        }

                        <button
                            className="dropdown-item"
                            onClick={logout_Api_call}
                        >
                            <i className="fa-solid fa-arrow-right-from-bracket mr-4"></i> Logout
                        </button>
                    </div>
                </li>

            </ul>
        </Nav>
    )
}

export default Navbar

const Nav = styled.div`

    .dropdown-menu-lg {
        max-width: 300px;
        min-width: 204px;
        padding: 0;
    }

    .three-line i {
        font-size: 18px;
    }

`;